import { useEffect, useRef, useState } from "react";
import { AmortizacaoInputCard } from "./components/AmortizacaoInputCard";
import { AmortizacaoResponse } from "./components/AmortizacaoResponse";

export default function CalculadoraAmortizacao() {
  const [results, setResults] = useState<AmortizacaoResultType | null>(null);
  const resultsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (results && resultsRef.current) {
      requestAnimationFrame(() => {
        resultsRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  }, [results]);

  const handleAddPlan = () => {
    requestAnimationFrame(() => {
      document.getElementById("amortizacao-extra")?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  };

  return (
    <div className="calc-amortizacao">
      <h1 className="text-2xl font-bold text-primary mb-6">
        Simulador de amortização de financiamento e empréstimos
      </h1>
      <AmortizacaoInputCard setResults={setResults} />
      {results && (
        <div ref={resultsRef}>
          <AmortizacaoResponse results={results} onAddPlan={handleAddPlan} />
        </div>
      )}
    </div>
  );
}
